<template>
  <div class="hero--info bg-faun">
    <div class="py-16 sm:py-24">
      <Container>
        <FadeIn class="text-center max-w-3xl mx-auto">
          <div class="mb-2 md:mb-4" v-if="content.pretitle">
            <span class="rounded-full mr-2 sm:mr-0 mb-2 sm:mb-0 bg-[#5a6ded] px-2 py-0 text-xs inline-block font-semibold leading-6 text-white no-underline">
              {{ content.pretitle }}
            </span>
          </div>
          <h1 id="main-title" class="text-3xl leading-[1.25] sm:text-4xl sm:leading-[1.2] md:text-5xl md:leading-[1.12] font-bold tracking-tight text-gray-900 lora">
            {{ content.title }}
          </h1>
          <div class="text-subtitle" v-interpolation v-html="content.subtitle"></div>
        </FadeIn>
      </Container>
    </div>
    <div class="-mt-10 pb-12 sm:pb-2" v-if="Array.isArray(stats) && stats.length > 0">
      <FadeIn v-if="stats.length > 2" class="relative">
        <div class="absolute inset-0 h-1/2 bg-faun" />
        <div class="relative mx-auto max-w-7xl px-6 lg:px-8">
          <div class="mx-auto max-w-4xl">
            <div class="rounded bg-white shadow-lg sm:grid sm:grid-cols-3">
              <div class="flex flex-col border-b border-[#e8e5de] bg-white p-6 text-center sm:border-0 sm:border-r">
                <div class="text-center">
                  <img
                  v-if="stats[0].image"
                  :src="useCdn(stats[0].image)"
                  :alt="stats[0].alt"
                  class="max-w-[80px] inline"
                  >
                  <Icon 
                  v-if="stats[0].icon"
                  :name="stats[0].icon"
                  color="#6073EE"
                  class="max-w-[80px] inline"
                  width="2.5em"
                  height="2.5em"
                  />
                </div>
                <div v-if="stats[0].title" v-html="stats[0].title" class="mt-6 text-xl font-semibold leading-7 tracking-tight text-gray-900"></div>
                <div v-if="stats[0].subtitle" v-html="stats[0].subtitle" class="mt-3 text-lg font-medium leading-6 text-gray-900"></div>
              </div>
              <div class="flex flex-col border-b border-t border-[#e8e5de] bg-white p-6 text-center sm:border-0 sm:border-l sm:border-r">
                <div class="text-center">
                  <img
                  v-if="stats[1].image"
                  :src="stats[1].image"
                  :alt="stats[1].alt"
                  class="max-w-[80px] inline"
                  >
                  <Icon 
                  v-if="stats[1].icon"
                  :name="stats[1].icon"
                  color="#6073EE"
                  class="max-w-[80px] inline"
                  width="2.5em"
                  height="2.5em"
                  />
                </div>
                <div v-if="stats[1].title" v-html="stats[1].title" class="mt-6 text-xl font-semibold leading-7 tracking-tight text-gray-900"></div>
                <div v-if="stats[1].subtitle" v-html="stats[1].subtitle" class="mt-3 text-lg font-medium leading-6 text-gray-900"></div>
              </div>
              <div class="flex flex-col border-t border-[#e8e5de] bg-white p-6 text-center sm:border-0 sm:border-l">
                <div class="text-center">
                  <img
                  v-if="stats[2].image"
                  :src="stats[2].image"
                  :alt="stats[2].alt"
                  class="max-w-[80px] inline"
                  >
                  <Icon 
                  v-if="stats[2].icon"
                  :name="stats[2].icon"
                  color="#6073EE"
                  class="max-w-[80px] inline"
                  width="2.5em"
                  height="2.5em"
                  />
                </div>
                <div v-if="stats[2].title" v-html="stats[2].title" class="mt-6 text-xl font-semibold leading-7 tracking-tight text-gray-900"></div>
                <div v-if="stats[2].subtitle" v-html="stats[2].subtitle" class="mt-3 text-lg font-medium leading-6 text-gray-900"></div>
              </div>
            </div>
          </div>
        </div>
      </FadeIn>
      <FadeIn v-else-if="stats.length > 1" class="relative">
        <div class="absolute inset-0 h-1/2 bg-faun" />
        <div class="relative mx-auto max-w-2xl px-6 lg:px-8">
          <div class="rounded bg-[#f9f8f6] sm:grid sm:grid-cols-2">
            <div class="flex flex-col border-2 border-[#e8e5de] rounded-t-lg sm:border-r-none sm:rounded-none sm:rounded-l-lg bg-white p-6 text-center">
              <div class="text-center mb-6" v-if="stats[0].image">
                <img
                :src="useCdn(stats[0].image)"
                :alt="stats[0].alt"
                class="max-w-[80px] inline"
                >
                <Icon 
                v-if="stats[0].icon"
                :name="stats[0].icon"
                color="#6073EE"
                class="max-w-[80px] inline"
                width="2.5em"
                height="2.5em"
                />
              </div>
              <div v-if="stats[0].title" v-html="stats[0].title" class="text-xl font-semibold leading-7 tracking-tight text-gray-900"></div>
              <div v-if="stats[0].subtitle" v-html="stats[0].subtitle" class="mt-3 text-lg font-medium leading-6 text-gray-900"></div>
            </div>
            <div class="flex flex-col border-[#e8e5de] bg-white p-6 text-center border-2 border-[#e8e5de] border-t-0 sm:border-t-2 sm:border-l-0 rounded-b-lg sm:rounded-none sm:rounded-r-lg">
              <div class="text-center mb-6" v-if="stats[1].image">
                <img
                v-if="stats[1].image"
                :src="stats[1].image"
                :alt="stats[1].alt"
                class="max-w-[80px] inline"
                >
                <Icon 
                v-if="stats[1].icon"
                :name="stats[1].icon"
                color="#6073EE"
                class="max-w-[80px] inline"
                width="2.5em"
                height="2.5em"
                />
              </div>
              <div v-if="stats[1].title" v-html="stats[1].title" class="text-xl font-semibold leading-7 tracking-tight text-gray-900"></div>
              <div v-if="stats[1].subtitle" v-html="stats[1].subtitle" class="mt-3 text-lg font-medium leading-6 text-gray-900"></div>
            </div>
          </div>
        </div>
      </FadeIn>
    </div>
  </div>
</template>

<script setup>
const props = defineProps({
  content: {
    type: Object,
    required: true,
  },
  stats: {
    type: Object,
    required: false
  }
})
</script>